import { render } from "./EmptyBookVariant.vue?vue&type=template&id=73a50d70&scoped=true"
import script from "./EmptyBookVariant.vue?vue&type=script&lang=js"
export * from "./EmptyBookVariant.vue?vue&type=script&lang=js"

import "./EmptyBookVariant.vue?vue&type=style&index=0&id=73a50d70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a50d70"],['__file',"src/views/Products/EmptyBookVariant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73a50d70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73a50d70', __exports__)) {
    api.reload('73a50d70', __exports__)
  }
  
  module.hot.accept("./EmptyBookVariant.vue?vue&type=template&id=73a50d70&scoped=true", () => {
    api.rerender('73a50d70', render)
  })

}


export default __exports__